import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/unit-converter")({
  component: UnitConverterLayout,
});

function UnitConverterLayout() {
  return <Outlet />;
}
